import { render, staticRenderFns } from "./wxpay_app.vue?vue&type=template&id=36abe912&scoped=true&"
import script from "./wxpay_app.vue?vue&type=script&lang=js&"
export * from "./wxpay_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36abe912",
  null
  
)

export default component.exports